<template>
  <div :class="$isDesktop && 'fit relative'">
    <div class="absolute-center text-center">
      <p>
        <QIcon
          name="ion-sad"
          size="5em"
        />
      </p>

      <p>{{ $t("load_error.error") }}</p>

      <QBtn
        color="primary"
        data-testid="reload-app-button"
        style="width: 200px"
        @click="reloadApp"
      >
        {{ $t("global.try_again") }}
      </QBtn>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoadError",
  methods: {
    reloadApp() {
      localStorage.removeItem("appHasReloaded");
      window.location.reload();
    },
  },
};
</script>
